'use client'

import { useId } from 'react'
import { Download } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button } from '@/components/ui/button'
import { useRequiredAppUpdate } from '@/hooks/use-required-app-update'

/**
 * "Hay una versión nueva" in Encuentro (ALU-115). Same rule as the classic
 * modal (`useRequiredAppUpdate`: native app below the server's minimum
 * version), same single way out (the store) and, like it, no close: the app
 * cannot go on until it is updated. A `surface` card on the `scrim`, with
 * `radius-lg`, `shadow-overlay` and one primary action.
 */
export function EncuentroAppUpdateModal() {
  const t = useTranslations('encuentro.frame.appUpdate')
  const storeUrl = useRequiredAppUpdate()
  const titleId = useId()
  const bodyId = useId()
  if (storeUrl === null) return null

  return (
    <div
      data-slot="app-update"
      className="fixed inset-0 z-10000 grid place-items-center bg-en-scrim p-6 font-en-sans text-en-ink"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={bodyId}
        className="grid w-full max-w-sm grid-cols-[minmax(0,1fr)] justify-items-center gap-3 rounded-en-lg bg-en-surface p-6 text-center shadow-en-overlay"
      >
        <span className="grid size-12 place-items-center rounded-en-full bg-en-surface-sunken">
          <Download aria-hidden className="size-6" />
        </span>
        <h2 id={titleId} className="text-en-subheading [overflow-wrap:anywhere]">
          {t('title')}
        </h2>
        <p id={bodyId} className="text-en-body text-en-ink-muted">
          {t('body')}
        </p>
        <Button look="encuentro" variant="primary" block asChild className="mt-2">
          <a href={storeUrl} target="_blank" rel="noopener noreferrer">
            {t('cta')}
          </a>
        </Button>
      </div>
    </div>
  )
}
